// Sad as it may be - The structure for Photo Groups, albums and the like is
// fairly complex & lost in time as we moved from things we used to use and things we don't
// need anymore.
// Now that we are updating the Album headers, information must go from the bottom of the pile (PhotoGroup component)
// To the top of the pile (AlbumHeader component), and as such, this context should help achieve that.
// The provider, will be at the top, and will be modified by the PhotoGroup component to serve the current photo group.
// The consumer, will be on the AlbumHeader component and use this information accordingly.
import React, { useState, createContext } from 'react';

const PhotoGroupContext = createContext(null);

const PhotoGroupContextProvider = ({ children }) => {
  const [photoGroup, setPhotoGroup] = useState(null);
  const [selectionSettings, setSelectionSettings] = useState({
    enabled: false,
    isSelectAll: false,
  });
  const [albumPhotoGroupFilter, setAlbumPhotoGroupFilter] = useState('');

  return (
    <PhotoGroupContext.Provider
      value={{
        photoGroup,
        setPhotoGroup,
        selectionSettings,
        setSelectionSettings,
        albumPhotoGroupFilter,
        setAlbumPhotoGroupFilter,
      }}
    >
      {children}
    </PhotoGroupContext.Provider>
  );
};

export { PhotoGroupContextProvider, PhotoGroupContext };
